var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-pcp-promo-stripe-wrapper",
      class: { "rb-pcp-promo-stripe-wrapper--skeleton": _vm.loading },
      attrs: { id: "rb-pcp-promo-stripe-wrapper" },
    },
    [!_vm.loading ? _vm._t("promo-stripe") : _vm._e()],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }